/**
 * --------------------------------------------
 * KANYOS SidebarMenu.js
 * License ANZAS
 * --------------------------------------------
 */

import $ from 'jquery'

/**
 * Constants
 * ====================================================
 */

const NAME = 'SidebarMenu'
const DATA_KEY = 'lte.sidebarmenu'
// const EVENT_KEY = `.${DATA_KEY}`
const JQUERY_NO_CONFLICT = $.fn[NAME]

const CLASS_NAME_NAV_ICON = 'nav-icon'
const CLASS_NAME_NAV_LINK = 'nav-link'
const CLASS_NAME_DISABLED = 'disabled text-gray'
const CLASS_NAME_LOADING_TRIGGER = 'loading-trigger'

// const EVENT_CHANGED = `changed${EVENT_KEY}`

// const SELECTOR_DATA_TOGGLE = '[data-widget="dropdown-list"]'

const Default = {
  dataSource: undefined,
  baseUrl: '',
  defaultMenuIconClass: `${CLASS_NAME_NAV_ICON} far fa-circle`,
  onChange(item) {
    return item
  }
}

/**
 * Class Definition
 * ====================================================
 */

class SidebarMenu {
  constructor(element, config) {
    this._config = config
    this._element = element

    this._init()
  }

  // Private

  _init() {
    this._element.empty()

    if (this._config.dataSource === undefined ||
      this._config.dataSource.MenuItems === undefined ||
      this._config.dataSource.MenuItems.length === 0) {
      return
    }

    for (let i = 0; i < this._config.dataSource.MenuItems.length; i++) {
      const menuItem = this._config.dataSource.MenuItems[i]

      if (!menuItem.Visible) {
        continue
      }

      let naviIconClass = menuItem.NaviIconClass !== null ?
        `${CLASS_NAME_NAV_ICON} ${menuItem.NaviIconClass}` :
        this._config.defaultMenuIconClass

      let naviLinkClass = !menuItem.Enabled ?
        `${CLASS_NAME_NAV_LINK} ${CLASS_NAME_DISABLED}` :
        CLASS_NAME_NAV_LINK

      // if (menuItem.Target === '_self') {
      //   naviLinkClass = `${naviLinkClass} ${CLASS_NAME_LOADING_TRIGGER}`
      // }

      const $navItem = $('<li class="nav-item" />')
        .append($(`<a href="#" class="${naviLinkClass}">`)
          .append($(`<i class="${naviIconClass}"></i>`))
          .append($(`<p>${menuItem.Title}<i class="right fas fa-angle-left"></i></p>`)))

      const $navTreeView = $('<ul class="nav nav-treeview nav-indent" />')

      for (let j = 0; j < menuItem.MenuItems.length; j++) {
        const subMenuItem = menuItem.MenuItems[j]

        if (!subMenuItem.Visible) {
          continue
        }

        naviIconClass = subMenuItem.NaviIconClass !== null ?
          `${CLASS_NAME_NAV_ICON} ${subMenuItem.NaviIconClass}` :
          this._config.defaultMenuIconClass

        naviLinkClass = !subMenuItem.Enabled ?
          `${CLASS_NAME_NAV_LINK} ${CLASS_NAME_DISABLED}` :
          CLASS_NAME_NAV_LINK

        if (subMenuItem.Target === '_self') {
          naviLinkClass = `${naviLinkClass} ${CLASS_NAME_LOADING_TRIGGER}`
        }

        $navTreeView.append($('<li class="nav-item nav-item-sm" />')
          .append($(`<a href="${this._config.baseUrl}${subMenuItem.Url}" target="${subMenuItem.Target}" class="${naviLinkClass}" />`)
            .append($(`<i class="${naviIconClass}"></i>`))
            .append($(`<p>${subMenuItem.Title}</p>`))
          )
        )
      }

      this._element.append($navItem.append($navTreeView))
    }
  }

  // Static

  static _jQueryInterface(config) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)

      if (!data) {
        data = $(this).data()
      }

      const _options = $.extend({}, Default, typeof config === 'object' ? config : data)
      const plugin = new SidebarMenu($(this), _options)

      $(this).data(DATA_KEY, typeof config === 'object' ? config : data)

      if (config === 'init') {
        plugin[config]()
      }
    })
  }
}

/**
 * Data API
 * ====================================================
 */

// $(window).on('load', () => {
//   SidebarMenu._jQueryInterface.call($(SELECTOR_DATA_TOGGLE))
// })

/**
 * jQuery API
 * ====================================================
 */

$.fn[NAME] = SidebarMenu._jQueryInterface
$.fn[NAME].Constructor = SidebarMenu
$.fn[NAME].noConflict = function () {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return SidebarMenu._jQueryInterface
}

export default SidebarMenu
